
const notificationDetail = require('./sale-fullcont-notification-obj')
var schedule             = []
var agreements           = []

export function start( data, result, htmlFc){  
    emptyVars(htmlFc)
    hasTrestictions    (data, result, htmlFc  )

}/**/

//return true for continues, false to stop
function hasTrestictions(data, result, htmlFc){ 
    if( result.restriction.val === "saleHasPayment" ){
        addBody({ type:'blockEdition', msg:`S `}, htmlFc)
        return true
    }

    return false 
}/**/

function addBody(detail, htmlFc){
    htmlFc.notification.insertAdjacentHTML("beforeend", notificationDetail.start(detail))  
}

function emptyVars(htmlFc){
    htmlFc.notification.innerHTML = ``
    schedule                      = []
    agreements                    = []    
}
